import { useCallback } from "react";

import firebase from "firebase/app";

import { useBlockingProgress } from "../components/blocking-progress";
import { useSnackbar } from "../components/snackbar";

export type GuestActionData =
    | AskForHelpData

export interface AskForHelpData {
    action: "ask for help";
    name: string;
    email: string;
    phoneNumber: string;
    message: string;
}

const guestAction: (data: GuestActionData) => Promise<firebase.functions.HttpsCallableResult>
    = firebase.app().functions("europe-west3").httpsCallable("Workflow-guestAction");

export const useGuestAction = (callback?: (action: GuestActionData["action"]) => void) => {
    const { block, unblock } = useBlockingProgress();
    const { openSnackbar } = useSnackbar();

    return useCallback((data: GuestActionData) => {
        block();

        guestAction(data)
            .then(() => {
                openSnackbar("success", "Besvarelsen er modtaget");
                unblock();
                if ( callback ) callback(data.action);
            })
            .catch(() => {
                openSnackbar("error", "Der skete en fejl. Besvarelsen er ikke blevet modtaget.");
                unblock();
            });

    }, [block, unblock, openSnackbar, callback]);
};
